/* eslint-disable react-hooks/exhaustive-deps */
import { usePromiseState } from "./use-promise-state"

/**
 * Fetch the result of a promise each time the deps change.
 * Used to fetch data from the server and rerender the component when the data is available.
 *
 * Ex. usePromise(() => fetch('/customers/' + id), [id])
 */
export function usePromise<T> (
  promiseGen: () => Promise<T>,
  deps: any[],
  opts: { defaultState?: T, setErrors?: (errors: string[]) => void } = {}
): T | undefined | null {
  return usePromiseState(promiseGen, deps, opts)[0]
}
